import { render } from "./EmployeePerformanceAppraisals.vue?vue&type=template&id=22a6a806&scoped=true"
import script from "./EmployeePerformanceAppraisals.vue?vue&type=script&lang=js"
export * from "./EmployeePerformanceAppraisals.vue?vue&type=script&lang=js"

import "./EmployeePerformanceAppraisals.vue?vue&type=style&index=0&id=22a6a806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a6a806"]])

export default __exports__